import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import SignIn from './components/SignIn';
import VoiceChat from './components/VoiceChat';
import AdminPanel from './components/AdminPanel';
import UserSettings from './components/UserSettings';

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <Router>
          <div className="min-h-screen bg-gradient-to-br from-gray-900 to-black text-white">
            <Routes>
            {/* Public Routes */}
            <Route path="/signin" element={<SignIn />} />
            
            {/* Protected Routes */}
            <Route
              path="/chat"
              element={
                <ProtectedRoute>
                  <div className="flex flex-col h-screen">
                    <Header />
                    <div className="flex-1">
                    <VoiceChat />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />

            {/* Admin Routes */}
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute>
                  <div className="flex flex-col h-screen">
                    <Header />
                    <div className="flex-1">
                      <AdminPanel />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />

            {/* User Settings Route */}
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <div className="flex flex-col h-screen">
                    <Header />
                    <div className="flex-1">
                      <UserSettings />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            
            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/chat" replace />} />
            
            {/* 404 redirect */}
            <Route path="*" element={<Navigate to="/chat" replace />} />
            </Routes>
          </div>
        </Router>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
